import { LDObject } from 'emt-library'

export type SentenceContext = {
  inscriptionSentence: string
  profileSentence: string
}

export type Sentence = {
  ownerSentence: SentenceContext
  borrowerSentence: SentenceContext
}

type Icon = {
  className?: string
  iconUrl?: string
}

type Type<T> = LDObject<T> & {
  slug: string
  sentence: Sentence
  subSentence?: Sentence
  icon?: Icon
}

export enum ChoiceConstraint {
  Required = 'required',
}

export type Choice<L = unknown, T extends Type<unknown> = Type<unknown>> = LDObject<L> & {
  slug: string
  sentence: Sentence
  constraint: ChoiceConstraint | null
  types: T[]
}

export type DisponibilityType = Type<'Type'>
export type DisponibilityChoice = Choice<'DisponibilityChoice', DisponibilityType>

export type DogAffinityType = Type<'Type'>
export type DogAffinityChoice = Choice<'DogAffinityChoice', DogAffinityType>

export const isOptionsChoiceValid = (options: Record<string, boolean>, choice: Choice) => {
  if (choice.constraint === ChoiceConstraint.Required) {
    return choice.types.some((type) => {
      return options[type.slug] === true
    })
  }

  return true
}
